@if (orderEditingService.useShopifyFlows) {
  <div class="refunds-handled-by-shopify-flow">
    <p class="body-14-medium">Refunds</p>
    <div class="shopify-flow-note">
      <pdq-icon icon="more_information" size="small" color="var(--on-surface-light)"></pdq-icon>
      <p class="body-12-medium">Refunds are handled by your Shopify Flow. Turn it off to edit manually.</p>
    </div>
  </div>
} @else {
  <pdq-radio-group
    [formControl]="refundHandlingTypeControl"
    labelVariant="field"
    [preserveTextCase]="true"
    label="Refunds"
    secondaryLabel="Refunds go to the original payment method.">
    <pdq-radio-button
      [value]="RefundHandlingType.AUTOMATIC"
      [checked]="refundHandlingTypeControl.value === RefundHandlingType.AUTOMATIC"
      [text]="automaticRefundOptionText"></pdq-radio-button>
    <pdq-radio-button
      [value]="RefundHandlingType.MANUAL"
      [checked]="refundHandlingTypeControl.value === RefundHandlingType.MANUAL"
      text="Refund manually in Shopify"></pdq-radio-button>
  </pdq-radio-group>
}
